const type = 'SET_CALL_EVENTS_LOADING';

const setCallEventsLoading = (data) => ({
  data,
  type,
});

export { type };
export default setCallEventsLoading;
